<div class="toro-header-alerts-container" *ngIf="turfGuardWidgetData?.highAlertsCount > 0 || turfGuardWidgetData?.lowAlertsCount > 0" [ngClass]="{'fade-on-resize': isResizing}">
    <fa-icon icon="info-circle"></fa-icon>
    <span>{{ 'STRINGS.SENSOR_ALERTS' | translate}}: {{headerAlertsInfo}}</span>
</div>
